import { getStoredValue, setStoredValue, useConfigContext } from "@WahooFitness/wahoo-offline-mfe";
import { useEffect } from "react";
import Bugsnag from "@bugsnag/js";
import { WSMWorkoutProfile } from "@WahooFitness/wsm-native/dist/esm/types/workout_profile";
import useSWR from "swr";
import { PLATFORM_ENUM } from "@WahooFitness/cloud-client-types";

/**
 * Some users have reported that their workout profiles are corrupted when they are offline.
 * This is a temporary hook that will report any corruption to Bugsnag.
 */
export const useCheckForProfileCorruption = (profile?: WSMWorkoutProfile) => {
  const { wahooToken, appVersion, platform } = useConfigContext();

  const { data: storedCheck, isLoading: storedCheckIsLoading } = useSWR(
    platform !== PLATFORM_ENUM.web && wahooToken && [wahooToken, "workoutProfileCorruptionCheck"],
    () => {
      return getStoredValue<string>("workoutProfileCorruptionCheck");
    }
  );

  useEffect(() => {
    if (
      platform !== PLATFORM_ENUM.web &&
      !storedCheckIsLoading &&
      storedCheck !== appVersion &&
      profile !== undefined &&
      profile.workout_type_id === undefined
    ) {
      Bugsnag.notify(
        new Error(`Possible offline corruption for workout profiles`),
        function (event) {
          event.severity = "warning";
          event.addMetadata("profile", profile);
        }
      );
      setStoredValue("workoutProfileCorruptionCheck", appVersion);
    }
  }, [appVersion, platform, profile, storedCheck, storedCheckIsLoading]);
};
